<template>
  <view-box
    v-show="$store.state.displaySettingsMenu"
    :heading="$t('settingsView.heading')"
    icon="mdi-cogs"
    style="overflow-y:auto;"
    class="view-box viewboxvisible remove-scroll-bar"
  >
    <v-card
      class="settings-menu-container"
      :style="$mq | mq({
        desktop:'width: 100%;'
      })"
    >
      <v-expansion-panels
        v-model="openedPanel"
        accordion
      >
        <v-expansion-panel
          v-if="$appConfig.showLanguageSelection"
        >
          <v-expansion-panel-header>{{ $t('settingsView.localization') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-btn
              v-for="entry in languages"
              :key="entry.title"
              style="margin:0 0.5rem;padding:0;min-width:44px;"
              @click="changeLang(entry.language)"
            >
              <flag
                :iso="entry.flag"
                :squared="false"
                style="font-size:2.5rem;"
              />
            </v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <imprint v-if="hideImprint != true"/>
        <privacy v-if="hidePrivacy != true"/>
        <v-expansion-panel
          v-if="responsibility.name !== 'Mensch und Maschine Infrastruktur GmbH'"
        >
          <v-expansion-panel-header>
            {{ $t('settingsView.hostInformation') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <h3>{{ $t('settingsView.host') }}:</h3>
            <v-img
              :src="`./${logo}`"
              width="50%"
              contain
              style="margin: 2.5% 0;"
            />
            <p>
              {{ responsibility.name }}<br>
              {{ responsibility.street }}<br>
              {{ responsibility.postcode }} {{ responsibility.city }}
            </p>
            <p>{{ responsibility.descr }}</p>
            <h3 v-if="!hideTechnicallyOperatedBy">
              {{ $t('settingsView.technicallyOperatedBy') }}:
            </h3>
            <v-img
              v-if="!hideTechnicallyOperatedBy"
              src="../../assets/logo-mum-320x63.png"
              width="50%"
              contain
              style="margin: 2.5% 0;"
            />
            <p v-if="!hideTechnicallyOperatedBy">
              Mensch und Maschine Infrastruktur GmbH<br>Christophstr. 7<br>70178 Stuttgart
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          v-for="(item, i) in additionalPanels"
          :key="i"
        >
          <!-- TEMP TODO -->
          <v-expansion-panel-header>
            {{ item.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="additionalPanels"
            v-html="item.htmlcontent"
          />
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </view-box>
</template>
<script>

import ViewBox from '../ViewBox.vue';
import Imprint from './imprint.vue';
import Privacy from './privacy.vue';
import {
  EventBus,
} from '../../event-bus';

export default {
  name: 'SettingsView',
  components: {
    ViewBox,
    Imprint,
    Privacy,
  },
  props: {},
  data() {
    return {
      openedPanel: 0,
      displayed: false,
      responsibility: this.$appConfig.responsibility,
      logo: this.$appConfig.logo,
      languages: [
        { flag: 'de', language: 'de', title: 'Deutsch' },
        { flag: 'gb', language: 'en', title: 'English' },
        { flag: 'fr', language: 'fr', title: 'Francais' },
        { flag: 'it', language: 'it', title: 'Italiano' },
      ],
      additionalPanels: this.$appConfig.additionalPanels,
      hideTechnicallyOperatedBy: this.$appConfig.hideTechnicallyOperatedBy,
      hideImprint: this.$appConfig.hideImprint,
      hidePrivacy: this.$appConfig.hidePrivacy,
    };
  },
  mounted() {
    EventBus.$on('openImprint', () => {
      this.openedPanel = 0;
    });
  },
  methods: {
    changeLang(language) {
      // TODO could be fancier
      this.$router.replace({ path: `/${language}`, query: this.$route.query })
        .catch(() => {
          /**
           *  If the website is refreshed at the mapcenter, the router url is equals to the current
           *  vuerouter path
           *  To avoid a error caused by "NavigationDuplicated"
           *  we just catch the error and do nothing
          */
        });
      this.$store.commit('changeLanguage', language);
      this.$root.$i18n.locale = language;
    },
  },
};

</script>
<style scoped>
  .remove-scroll-bar {
    -ms-overflow-style: none;  /* IE 10+ */
    scrollbar-width: none;  /* Firefox */
  }
  .remove-scroll-bar::-webkit-scrollbar {
    display: none;
  }
  .additionalPanels {
    flex-direction: column;
    padding: 0 24px 16px;
  }
  @media (min-width: 1250px) {
    .viewboxvisible {
      visibility: visible;
    }
  }
</style>
